import { SettingsPage } from '~/lib/stores/menu';

export interface MenuItem {
  id: SettingsPage;
  icon: string;
  text: string;
  isComingSoon?: boolean;
  isTeamAdmin?: boolean;
}

export interface MenuConfig {
  title: string;
  items: MenuItem[];
}

export const PROJECT_MENU_ITEMS: MenuConfig = {
  title: 'Project Settings',
  items: [
    {
      id: SettingsPage.Project,
      icon: 'i-heroicons:cog-6-tooth',
      text: 'General',
    },
    {
      id: SettingsPage.Domains,
      icon: 'i-ph:globe',
      text: 'Domains & Hosting',
    },
    { id: SettingsPage.Analytics, icon: 'i-heroicons:chart-bar', text: 'Analytics' },
    { id: SettingsPage.DatabaseSection, icon: 'i-heroicons:circle-stack', text: 'Database', isComingSoon: true },
    { id: SettingsPage.Authentication, icon: 'i-heroicons:shield-check', text: 'Authentication', isComingSoon: true },
    {
      id: SettingsPage.EdgeFunctions,
      icon: 'i-bolt:edge-functions',
      text: 'Server Functions',
    },
    {
      id: SettingsPage.Secrets,
      icon: 'i-lucide:key-round',
      text: 'Secrets',
    },
    {
      id: SettingsPage.UserManagement,
      icon: 'i-bolt:user-management',
      text: 'User Management',
      isComingSoon: true,
    },
    { id: SettingsPage.FileStorage, icon: 'i-heroicons:folder-open', text: 'File Storage', isComingSoon: true },
    {
      id: SettingsPage.KnowledgeProject,
      icon: 'i-ph:lightbulb',
      text: 'Knowledge',
    },
    { id: SettingsPage.Backups, icon: 'i-ph:clock-counter-clockwise', text: 'Backups' },
  ],
};

export const PERSONAL_MENU_ITEMS: MenuConfig = {
  title: 'Personal Settings',
  items: [
    { id: SettingsPage.General, icon: 'i-heroicons:cog-6-tooth', text: 'General' },
    { id: SettingsPage.SubscriptionAndTokens, icon: 'i-ph:coin-vertical', text: 'Subscription & Tokens' },
    { id: SettingsPage.Applications, icon: 'i-heroicons:squares-plus', text: 'Applications' },
    { id: SettingsPage.Cloud, icon: 'i-heroicons:cloud', text: 'Cloud' },
    { id: SettingsPage.KnowledgePersonal, icon: 'i-ph:lightbulb', text: 'Knowledge' },
    { id: SettingsPage.FeaturePreviews, icon: 'i-heroicons:beaker', text: 'Experimental features' },
  ],
};

export const TEAM_MENU_ITEMS: MenuConfig = {
  title: 'Team',
  items: [
    { id: SettingsPage.Team, icon: 'i-heroicons:user-group', text: 'Team' },
    { id: SettingsPage.SubscriptionAndTokens, icon: 'i-ph:coin-vertical', text: 'Subscription & Tokens' },
    { id: SettingsPage.Cloud, icon: 'i-heroicons:cloud', text: 'Cloud', isTeamAdmin: true },
    { id: SettingsPage.KnowledgeTeam, icon: 'i-ph:lightbulb', text: 'Knowledge' },
    {
      id: SettingsPage.PrivateRegistries,
      icon: 'i-heroicons:cube',
      text: 'Private registries',
      isTeamAdmin: true,
    },
    { id: SettingsPage.PackagesKnowledge, icon: 'i-tabler:cube-spark', text: 'Packages knowledge', isTeamAdmin: true },
  ],
};
